<div class="tab-header">New Venue</div>

<div class="form-container">
  <form [formGroup]="form">
    <div class="subheader">
      Add Venue
    </div>
    <div class="new-dashboard-card" *ngIf="shouldShowMoveVenueCreation()">
      <div>
        <h4>Venue creation has moved to our new dashboard!</h4>
        <h6>Follow this link to go there. Login with the same credentials. Text us with any issues at (646)-832-4695.</h6>
      </div>
      <button
        class="primary-medium-icon-left new-dashboard-card-button"
        id="dashboard-link"
        (click)="onClickDashboardRedirect()"
      >
        <i-feather name="external-link" class="icon"></i-feather>Take Me There
      </button>
    </div>
    <div *ngIf="!shouldShowMoveVenueCreation()">
    <div class="form-content">
      <div class="form-section">
        <label>
          <div class="subheading2 required">APP VISIBILITY</div>
        </label>
        <div class="form-group ">
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="visible"
                formControlName="isActive"
                [value]="true"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="visible"
                >Visible</label
              >
            </div>
          </div>
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="hidden"
                formControlName="isActive"
                [value]="false"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="hidden"
                >Hidden</label
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="venue_name">
            <div class="subheading2">VENUE NAME</div>
          </label>
          <input
            type="text"
            class="form-control form-control-lg body2"
            id="venue_name"
            formControlName="name"
            maxlength="30"
          />
        </div>
        <div class="form-group">
          <div class="thumbnail-container">
            <div class="subheading2">
              THUMBNAIL (100X100)
            </div>
            <div class="image-container">
              <img src="{{ image }}" *ngIf="imageSelected()" />
              <div class="form-group">
                <input
                  class="file-input add body2"
                  type="file"
                  (change)="selectImage($event)"
                  accept=".png,.jpg"
                  *ngIf="!imageSelected()"
                />
                <input
                  class="file-input change body2"
                  type="file"
                  (change)="selectImage($event)"
                  accept=".png,.jpg"
                  *ngIf="imageSelected()"
                />
              </div>
              <div class="placeholder" *ngIf="!imageSelected()"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-divider"></div>
      <div class="form-section">
        <div class="form-group required">
          <label for="sd">
            <div class="subheading2">
              SHORT DESCRIPTION
              <b>({{ form.controls.thumbnail.value.length }}/50)</b>
            </div>
          </label>
          <input
            type="text"
            maxlength="50"
            class="form-control body2"
            id="sd"
            formControlName="thumbnail"
          />
        </div>
        <div class="form-group required">
          <label for="ld">
            <div class="subheading2">
              LONG DESCRIPTION
              <b>({{ form.controls.description.value.length }}/200)</b>
            </div>
          </label>
          <textarea
            maxlength="200"
            class="form-control body2"
            id="ld"
            rows="4"
            formControlName="description"
          ></textarea>
        </div>
        <label for="redirect">
          <div class="subheading2">APP REDIRECT</div>
        </label>
        <div id="redirect" class="form-group">
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="redirect_active"
                formControlName="redirect"
                [value]="true"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="redirect_active"
                >Active</label
              >
            </div>
          </div>
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="redirect_inactive"
                formControlName="redirect"
                [value]="false"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="redirect_inactive"
                >Inactive</label
              >
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="form.controls.redirect.value">
          <label for="venue_name">
            <div class="subheading2">REDIRECT URL</div>
          </label>
          <input
            type="text"
            class="form-control form-control-lg body2 "
            [ngClass]="{ disabled: !form.controls.redirect.value }"
            id="redirect_url"
            formControlName="redirectUrl"
          />
        </div>
      </div>

      <div class="form-divider"></div>
      <div class="form-section">
        <label for="redirect">
          <div class="subheading2">BANNER AD STATUS</div>
        </label>
        <div id="redirect" class="form-group">
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="banner_visible"
                formControlName="isBannerActive"
                [value]="true"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="banner_visible"
                >Visible</label
              >
            </div>
          </div>
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="banner_hidden"
                formControlName="isBannerActive"
                [value]="false"
                class="radio-venue custom-control-input body2"
              />
              <label class="custom-control-label body2" for="banner_hidden"
                >Hidden</label
              >
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="isBannerActive">
          <div class="thumbnail-container">
            <div class="subheading2">
              BANNER AD IMAGE (320X50)
            </div>
            <div class="banner-image-container">
              <img src="{{ bannerImage }}" *ngIf="bannerSelected()" />
              <div class="form-group">
                <input
                  class="file-input add body2"
                  type="file"
                  (change)="selectBannerImage($event)"
                  accept=".png,.jpg"
                  *ngIf="!bannerSelected()"
                />
                <input
                  class="file-input change body2"
                  type="file"
                  (change)="selectBannerImage($event)"
                  accept=".png,.jpg"
                  *ngIf="bannerSelected()"
                />
              </div>
              <div class="ad-placeholder" *ngIf="!bannerSelected()"></div>
            </div>
          </div>
        </div>

        <div class="app-status-container" *ngIf="isBannerActive">
          <div class="section-label subheading2">
            BANNER REDIRECT STATUS
          </div>
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="bannerRedirectActive"
                formControlName="isBannerRedirectActive"
                [value]="true"
                class="custom-control-input"
              />
              <label
                class="custom-control-label body2"
                for="bannerRedirectActive"
                style="line-height: 32px;"
                >On</label
              >
            </div>
          </div>
          <div class="form-check form-check-inline">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="bannerRedirectInactive"
                formControlName="isBannerRedirectActive"
                [value]="false"
                class="custom-control-input"
              />
              <label
                class="custom-control-label body2"
                for="bannerRedirectInactive"
                style="line-height: 32px;"
                >Off</label
              >
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="isBannerActive && isBannerRedirectActive"
        >
          <label for="bannerRedirectUrl">
            <div class="section-label subheading2">BANNER REDIRECT URL</div>
          </label>
          <input
            type="text"
            class="form-control form-control-lg body2"
            id="bannerRedirectUrl"
            formControlName="bannerRedirectUrl"
            placeholder="Ex. https://www.lineleap.com/brand-ambassadors"
            maxlength="150"
          />
        </div>

        <div *ngIf="venues$ | async as venues">
          <div
            type="submit"
            class="submit-city-container"
            (click)="validate(venues)"
          >
            <div class="label1" style="color:white">{{ button }}</div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </form>
</div>

<!-- <div class="d-flex justify-content-center">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="venue_name">
        <div class="subheading1">VENUE NAME</div>
      </label>
      <input type="text" class="form-control form-control-lg body2" id="venue_name" formControlName="name"
        maxlength="30" />
    </div>

    <div class="form-group ">
      <label for="city">
        <div class="subheading1">CITY</div>
      </label>
      <input type="text" class="form-control form-control-lg body2" id="city" disabled
        placeholder="{{ venue.cityName + ', ' + this.venue.cityState }}" />
    </div>

    <div class="form-group required">
      <label for="sd">
        <div class="subheading1">
          SHORT DESCRIPTION
          <b>({{ form.controls.thumbnail.value.length }}/100)</b>
        </div>
      </label>
      <textarea maxlength="100" class="form-control body2" id="sd" rows="3" formControlName="thumbnail"></textarea>
    </div>

    <div class="form-group required">
      <label for="ld">
        <div class="subheading1">
          LONG DESCRIPTION
          <b>({{ form.controls.description.value.length }}/200)</b>
        </div>
      </label>
      <textarea maxlength="200" class="form-control body2" id="ld" rows="4" formControlName="description"></textarea>
    </div>
  </form>

  <div class="divider"></div>

  <form [formGroup]="form">
    <label for="redirect">
      <div class="subheading1">APP REDIRECT</div>
    </label>
    <div id="redirect" class="form-group">
      <div class="form-check form-check-inline">
        <div class="custom-control custom-radio">
          <input type="radio" id="redirect_active" formControlName="redirect" [value]="true"
            class="radio-venue custom-control-input body2" />
          <label class="custom-control-label body2" for="redirect_active">Active</label>
        </div>
      </div>
      <div class="form-check form-check-inline">
        <div class="custom-control custom-radio">
          <input type="radio" id="redirect_inactive" formControlName="redirect" [value]="false"
            class="radio-venue custom-control-input body2" />
          <label class="custom-control-label body2" for="redirect_inactive">Inactive</label>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="form.controls.redirect.value">
      <label for="venue_name">
        <div class="subheading1">REDIRECT URL</div>
      </label>
      <input type="text" class="form-control form-control-lg body2 "
        [ngClass]="{ disabled: !form.controls.redirect.value }" id="redirect_url" formControlName="redirectUrl" />
    </div>

    <label>
      <div class="subheading1">APP VISIBILITY</div>
    </label>
    <div class="form-group">
      <div class="form-check form-check-inline">
        <div class="custom-control custom-radio">
          <input type="radio" id="visible" formControlName="isActive" [value]="true"
            class="radio-venue custom-control-input body2" />
          <label class="custom-control-label body2" for="visible">Visible</label>
        </div>
      </div>
      <div class="form-check form-check-inline">
        <div class="custom-control custom-radio">
          <input type="radio" id="hidden" formControlName="isActive" [value]="false"
            class="radio-venue custom-control-input body2" />
          <label class="custom-control-label body2" for="hidden">Hidden</label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="thumbnail-container">
        <div class="subheading1">
          THUMBNAIL
        </div>
        <div class="image-container">
          <img src="{{ image }}" *ngIf="imageSelected()" />
          <div class="form-group">
            <input class="file-input add body2" type="file" (change)="selectImage($event)" accept=".png,.jpg"
              *ngIf="!imageSelected()" />
            <input class="file-input change body2" type="file" (change)="selectImage($event)" accept=".png,.jpg"
              *ngIf="imageSelected()" />
          </div>
          <div class="placeholder" *ngIf="!imageSelected()"></div>
        </div>
      </div>
    </div>

    <div type="submit" class="submit-city-container label1" (click)="validate()">
      <p>Save Changes</p>
    </div>
  </form>
</div> -->
